import { ClickAwayListener, Grow, Popper } from '@material-ui/core';
import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { Nullable } from '../../Shared/Types';
import { primary } from '../../Styles/Colours';
import { Button, ButtonGroupStyle, ButtonMode, ButtonProps, ButtonSize, ButtonVariant } from '../Button';
import { ArrowDropDownIcon } from '../Icons';
import styles from './MenuButton.module.scss';

export const MenuItem: React.FC<{
    title: string;
    testId: string;
    disabled?: boolean;
    startIcon?: React.ReactNode;
    onClick?(e: React.MouseEvent<HTMLDivElement>): void;
}> = props => {
    const containerClasses = classNames(styles.menuItem, {
        [styles.menuItemDisabled]: !!props.disabled
    });

    return (
        <div
            className={containerClasses}
            onClick={e => {
                if (props.onClick) props.onClick(e);
            }}
        >
            <span className={styles.menuItemTitle} data-test-id={props.testId}>
                {!!props.startIcon && <span className={styles.icon}>{props.startIcon}</span>}
                {props.title}
            </span>
        </div>
    );
};

export const MenuDivider = () => <div className={styles.menuDivider} />;

export const MenuButton: React.FC<
    ButtonProps & {
        label: React.ReactNode;
        testId: string;
        disabled?: boolean;
        startIcon?: React.ReactNode;
        endIcon?: React.ReactNode;
        children(config: { closeMenu: () => void }): React.ReactNode;
    }
> = props => {
    const { label, ...buttonProps } = props;
    const buttonRef = useRef<Nullable<HTMLButtonElement>>(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => {
        setMenuOpen(false);
    };

    const editButtonClick = () => setMenuOpen(!menuOpen);

    return (
        <>
            <Button
                {...buttonProps}
                ref={buttonRef}
                testId={props.testId}
                size={ButtonSize.small}
                mode={ButtonMode.border}
                variant={ButtonVariant.light}
                buttonGroup={ButtonGroupStyle.Left}
                endIcon={<ArrowDropDownIcon noPadding size={'20'} color={primary} />}
                onClick={editButtonClick}
            >
                {label}
            </Button>
            <Popper
                open={menuOpen}
                anchorEl={buttonRef.current}
                placement='bottom-end'
                className={styles.popper}
                modifiers={{
                    flip: {
                        enabled: true
                    },
                    preventOverflow: {
                        enabled: true,
                        boundariesElement: 'scrollParent'
                    }
                }}
            >
                <ClickAwayListener onClickAway={closeMenu}>
                    <Grow in style={{ transformOrigin: 'top right' }}>
                        <div className={styles.addMenu}>
                            {props.children({
                                closeMenu
                            })}
                        </div>
                    </Grow>
                </ClickAwayListener>
            </Popper>
        </>
    );
};
